const pairUnitComponent = class extends HTMLElement {
    connectedCallback() {
        const buttons = this.querySelectorAll(".line-item-property--pair-unit");
        let buttonPriceSingle = document.querySelector(".product-form__payment-container__price").innerText;
        const [price, currency] = buttonPriceSingle.split(/(?<=\d)(?=[^\d\s])/);

        buttons.forEach(button => {
            button.addEventListener("click", e => this.updateQty(e, price, currency));
        });
    }

    updateQty(e, price, currency) {
        const buttons = this.querySelectorAll(".line-item-property--pair-unit");

        buttons.forEach(button => {
            button.classList.remove("selected");
        });

        const buttonPrice = document.querySelector(".product-form__payment-container__price");
        const target = e.currentTarget;
        target.classList.toggle("selected");
        const inputQuantity = document.querySelector('input[name="quantity"]');
        const shopifyForm = document.querySelector("form.shopify-product-form");


        const regex = /([\d.]+)\s*(\S+)/;
        const match = price.match(regex);
        const number = parseFloat(match[1]); // Parse the number as a float
        const currencySymbol = match[2];

        if (inputQuantity == null) {
            if (shopifyForm) {
                const newInput = document.createElement("input");
                newInput.setAttribute("name", "quantity");
                newInput.setAttribute("type", "hidden");
                newInput.value = target.dataset.quantity;
                shopifyForm.appendChild(newInput);


                if (match) {

                    const resultString = number * target.dataset.quantity + ' ' + currencySymbol;
                    buttonPrice.innerText = resultString;
                }
            }
        } else {
            inputQuantity.value = target.dataset.quantity;
            const resultString = number * target.dataset.quantity + ' ' + currencySymbol;

            buttonPrice.innerText = resultString;
        }
    }


};

window.customElements.define("pair-unit", pairUnitComponent);
